<template>
  <div class="col-12 col-lg-12 u-marg-t-ml u-left--sm">
    <p class="t-h2--md c-product-capacity-text ordered-props"><span class="n-label n-label--black">2</span> <span>{{ $t('Choose a storage size') }}{{ setSpace() }}:</span> <span class="u-grey-text">{{ currentCapacity }}</span></p>
    <div class="c-product-page__capcity-container d-flex">
       <div
        v-for="(item, index) in list"
        :key="`${index}-item`"
        :class="[
          'gtm-section-product-capacity t-button t-button--rounded u-marg-t-xxs u-marg-r-xxs product',
          item.selected ? 'is-active' : '',
          item[Object.keys(item)[0]].is_salable ? '' : 'product--unavailable'
        ]"
        :data-capacity="displayLabel(item)"
        @click="onSelected(index)">
        {{ displayLabel(item) }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import Helpers from '~plugins/Helpers'

  import { UpdatedAvailablePlans, AddSpaceFr } from './Mixins/CustomOptionsMixins'

  export default {
    props: {
      capacityList: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        list: [],
        product: {},
        firstSalable: {},
        firstSalableIndex: 0,
        noOneForSale: false
      }
    },
    computed: {
      ...mapGetters({
        currentProduct: 'GET_CURRENT_PRODUCT',
        productInformations: 'GET_PRODUCT_INFORMATIONS',
        $t: 'GET_TRAD'
      }),
      currentCapacity(){
        return this.currentProduct.capacity.swatch
      }
    },
    beforeMount () {

      this.product = {...this.currentProduct}
      this.sortListBySelected()

      if (this.firstSalableIndex !== -1) {
        this.product.capacity = {
          ...this.firstSalable[Object.keys(this.firstSalable)[0]],
          index: this.firstSalableIndex
        }
      } else {
        // If there is no salable capacity we disabled the button
        this.updateButtonState('disabled')
      }

      if (Helpers.getParamValue('capacity') && Helpers.getParamValue('capacity') !== '') {

        const capacityFromUrl = Helpers.getParamValue('capacity')

        this.list = this.list.map(capacity => {
          if (Object.keys(capacity)[0] === capacityFromUrl) {
            return {...capacity, selected: true}
          } else {
            return {...capacity, selected: false}
          }
        })

        /**
         * In case nothing is selected because sometimes the user has selected a capacity available in one color
         * but not available in another color, we make sure the first capacity is selected in front
         */
        const checkIfSomethingIsSelected = this.list.findIndex(capacity => capacity.selected)

        if (checkIfSomethingIsSelected === -1) {
          this.list[0].selected = true
          this.product.capacity = {
            ...this.firstSalable[Object.keys(this.firstSalable)[0]],
            index: this.firstSalableIndex
          }
        } else {
          const findSelectedIndex = this.list.findIndex(capacity => capacity.selected)

          this.firstSalableIndex = findSelectedIndex

          this.firstSalable = this.list[findSelectedIndex]

          this.product.capacity = {
            ...this.firstSalable[Object.keys(this.firstSalable)[0]],
            index: findSelectedIndex
          }
        }
      }

      /**
       * If the firstSalableIndex is different from the first capacity
       * we need to update the sku, the plan and the color globally
       */
      if (this.firstSalableIndex !== 0) {
        this.updateColorAndPlans(this.firstSalableIndex)
      }

      this.setCurrentProduct({currentProduct: this.product})

    },
    watch: {
      /**
       * Watch the capacityList props
       *
       * Every time the capacityList change we update the `this.list` array
       * and with `this.product.capacity` we update the current selected capacity
       */
      'capacityList': {
        handler () {

          this.sortListBySelected()
          this.product = {...this.currentProduct}

            const order = ["5486","5489", "5487", "5604","5940"];

            this.product.color.products.sort((a, b) => {
              const indexA = order.indexOf(a.capacity_value);
              const indexB = order.indexOf(b.capacity_value);

              // If both values are in the order array, sort them accordingly
              if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
              }

              // If one of the values is in the order array, prioritize it
              if (indexA !== -1) {
                return -1;
              }

              if (indexB !== -1) {
                return 1;
              }

              // If neither value is in the order array, sort them by capacity_value as numbers
              const capacityA = parseInt(a.capacity_value);
              const capacityB = parseInt(b.capacity_value);

              return capacityA - capacityB;
            });


          if (this.product.capacity.index === this.firstSalableIndex) {
            this.product.capacity = {
              ...this.firstSalable[Object.keys(this.firstSalable)[0]],
              index: this.firstSalableIndex
            }
          }

          this.setCurrentProduct({currentProduct: this.product})
        },
        deep: true
      }
    },
    mounted () {
      // Because we can't control the load of the native magento form
      // we check every 500ms if the form exists
      const timer = setInterval(() => {
        const capacity = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.currentProduct.capacity.id}`)

        if (capacity) {
          this.product = this.currentProduct
          capacity.click()
          clearInterval(timer)

          // enable the add to cart button
          this.product.formReady = true
          this.setCurrentProduct({currentProduct: this.product})
        }
      }, 500)
    },
    methods: {
      ...mapActions({
        setCurrentProduct: 'SET_CURRENT_PRODUCT'
      }),
      ...mapMutations({
        updateButtonState: 'UPDATE_ADD_TO_CART_BUTTON_STATE',
      }),
      setSpace(){
        return AddSpaceFr(this.productInformations)
      },
      sortListBySelected () {
        this.list = [...this.capacityList]

        this.noOneForSale = !this.list.filter(e => e.is_salable === true).length
        if(this.noOneForSale){
          this.list.forEach((e,i) => {
            if(e.selected === true){
              this.list[i].selected = false
            }
          });
          this.list[0].selected = true         
        }

        this.firstSalable = this.list.find(capacity => capacity[Object.keys(capacity)[0]].is_salable)
        this.firstSalableIndex = this.list.findIndex(capacity => capacity[Object.keys(capacity)[0]].is_salable)

        if (this.firstSalableIndex !== -1) {
          /**
           * If the current capacity is not the same as the firstSalableIndex it means, it was set in the ColorSwatch component so
           * we take this capacity
           *
           * If the current capacity index is the same as firstSalableIndex, this is the first load or the user didn't change the capacity so we fallback to firstSalable capacity found
           */
          let selectedCapacity = this.product.capacity.index === this.firstSalableIndex ? this.product.capacity.swatch : Object.keys(this.firstSalable)[0]

          // In the case of first load this.product.capacity.swatch will be undefined so we make sure we take the firstSalable
          if (selectedCapacity === 'undefined') {
            selectedCapacity = Object.keys(this.firstSalable)[0]
          }

          this.list = this.list.map(capacity => {
            if (Object.keys(capacity)[0] === selectedCapacity) {
              return {...capacity, selected: true}
            } else {
              return {...capacity, selected: false}
            }
          })

          /**
           * In case nothing is selected because sometimes the user has selected a capacity available in one color
           * but not available in another color, we make sure the first capacity is selected in front
           */
          const checkIfSomethingIsSelected = this.list.findIndex(capacity => capacity.selected)

          if (checkIfSomethingIsSelected === -1) this.list[0].selected = true
        }
      },
      displayLabel (item) {
        return Object.keys(item)[0]
      },
      updateColorAndPlans (index) {
        // We update the with the current color
        // because in the color array every capacity is also listed and available
        if(index === -1){
          index = 0
          this.onSelected(index)
        }
        const currentSku = this.product.color.products[index].sku

        // Update the availability of the color with the correct capacity
        this.product.color.availability =  this.product.color.products[index].availability
        this.product.color.availability_color =  this.product.color.products[index].availability_color

        this.product.sku = currentSku

        let defaultAvailablePlans = [...this.productInformations.plans[currentSku]]
        let filterAvailablePlans = [...this.productInformations.plans[currentSku]]

        this.product.availablePlans = UpdatedAvailablePlans({
          defaultAvailablePlans,
          filterAvailablePlans,
          planSku: this.product.plan.sku
        })
      },
      onSelected (index) {
          // if the user select a capacity which is not salable disable button
          if (!this.list[index][Object.keys(this.list[index])[0]].is_salable) {
              this.updateButtonState('disabled')
          } else {
              this.updateButtonState('enabled')
          }

        // Clone this.currentProduct
        // Update this.product if something has changed in the global state
        this.product = {...this.currentProduct}

        for (let i = 0; i < this.list.length; i++) {
          this.list[i].selected = false
        }

        this.list[index].selected = true

        this.product.capacity = {
          id: this.list[index][Object.keys(this.list[index])[0]].id,
          swatch: Object.keys(this.list[index])[0],
          index: index
        }

        this.updateColorAndPlans(index)

        this.setCurrentProduct({currentProduct: this.product})

        const capacity = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.currentProduct.capacity.id}`)
        const selectedCapacityInNativeInput = document.querySelector(`input[name="super_attribute[${this.productInformations.super_attributes.device_capacity.id}]"]`).value

        if (
          capacity &&
          !capacity.disabled &&
          selectedCapacityInNativeInput !== this.currentProduct.capacity.id
          ) {
          capacity.click()
        }
      },
      isNotFirst (index) {
        return index > 0 ? true : false
      },
      customSortSS(data) {
            const order = ["5489", "5487", "5604"];
            data.products.sort((a, b) => {
              const indexA = order.indexOf(a.capacity_value);
              const indexB = order.indexOf(b.capacity_value);

              // If both values are in the order array, sort them accordingly
              if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
              }

              // If one of the values is in the order array, prioritize it
              if (indexA !== -1) {
                return -1;
              }

              if (indexB !== -1) {
                return 1;
              }

              // If neither value is in the order array, sort them by capacity_value as numbers
              const capacityA = parseInt(a.capacity_value);
              const capacityB = parseInt(b.capacity_value);

              return capacityA - capacityB;
            });
          }
    }
  }
</script>
